import { lazy } from "react";

export const TermedEmployeeNavbar = lazy(() => import("./TermedEmployeeNavbar"));
